import { Card, Modal, } from 'react-bootstrap';
import Spinner from '#Components/Spinner'
import { useMemo } from 'react';
const { Header, Body, Footer } = Card; 

export default function MessageSuccess(props) {

    const {customContent, setModalProps} = props //make sure customContent is an array so I can map over it

    const spinnerOptions = useMemo(() => {
        return {
            lineWidth: 3,
            petals: 9,
            // tailLength: 'long',
            radius: 50,
            // loopCount: 1,
            persist: true,
            counterSpin: true,
            onClick: () => setModalProps({ showing: false }) //closes modal without prematurely resetting props like callback
        }
    }, [])

    return (
        <Modal.Body>
            <Card style={{}}>
                <Header className="text-center rocky" >
                    <div className="mt-1">
                        Thanks for reaching out!
                    </div>
                </Header>
                <Body className="avenir">
                    <div className="d-flex">
                        <ul className="rounded" style={{backgroundColor: 'var(--light)', color: 'var(--dark)'}}>
                            {customContent.map((el, i) => <li key={i}>{el.field}: {el.value}</li>)}
                        </ul>
                        <div className="d-flex justify-content-center">
                            <div className="align-self-center">
                                <Spinner options={spinnerOptions}></Spinner>
                            </div>
                        </div>
                    </div>
                </Body>
                <Footer className="text-center rocky" >
                    <div className="mt-1">
                        I'll be in touch soon.
                    </div>
                </Footer>
            </Card>
        </Modal.Body>
    )
}